var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackAndSupportHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0072b2;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "feedback_and_support_help"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 300,
    cy: 300,
    r: 300
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M420.86,152.39h0c-11.21-17-27.26-30.68-47.69-40.53-20.26-9.76-43.85-14.71-70.13-14.71-28.3,0-53.5,5.93-74.88,17.62s-38,26.76-49.19,44.72-17,36.24-17,54.05c0,9.78,4,18.87,12,27a39.72,39.72,0,0,0,29.5,12.35c13.58,0,31.56-5.94,40.11-34.24,6-17.9,13.27-31.53,21.68-40.51,7.79-8.31,20.52-12.53,37.84-12.53,14.92,0,26.67,4.17,35.94,12.73s13.56,18.49,13.56,30.72a33.65,33.65,0,0,1-4.31,16.82,69.15,69.15,0,0,1-11.53,15.26c-4.87,4.86-12.94,12.24-24,21.92a425.61,425.61,0,0,0-31,29.52,103.81,103.81,0,0,0-19.35,30.28c-4.88,11.52-7.35,25.24-7.35,40.78,0,13.53,3.81,24.05,11.33,31.24s16.69,10.75,27.5,10.75c20.7,0,33.72-11.25,37.66-32.54,1.88-8.39,3.3-14.29,4.22-17.55a49.4,49.4,0,0,1,3.6-9.05,51.9,51.9,0,0,1,7.14-10,175.17,175.17,0,0,1,13.76-13.76c21.5-19.22,36.65-33.13,45-41.34A127,127,0,0,0,428,250.79c6.54-12.12,9.85-26.33,9.85-42.25A100.66,100.66,0,0,0,420.86,152.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.8,435.11a45.54,45.54,0,1,0,45.55,45.54A45.59,45.59,0,0,0,299.8,435.11Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackAndSupportHelp);
export default __webpack_public_path__ + "static/media/feedback_and_support_help.b8a09b0a26d7584d630e0d7ffb6584d0.svg";
export { ForwardRef as ReactComponent };